import PosthogService from '~/services/posthog/PosthogService';

export interface IOpenShiftAutoconfirmEligibleSelectedPayload {
  autoConfirm: 'on' | 'off';
  designDate: number;
}

/**
 * Fires when a user turns autoconfirm eligible professionals ON/OFF on the open shift edit page
 * Event: dental_portal:open_shift:autoconfirm_eligible_selected
 */
export function fireOpenShiftAutoconfirmEligibleSelected(
  payload: IOpenShiftAutoconfirmEligibleSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:open_shift:autoconfirm_eligible_selected',
    {
      'auto-confirm': payload.autoConfirm,
      design_date: payload.designDate,
    },
  );
}
